import React from "react";
import "../styles/policy.css";

const privacyPolicy = () => {
  return (
    <>
      <section className="policy">
        <h1>Privacy Policy</h1>
        <p>
          We are committed to protecting your privacy. You can navigate the
          majority of our site without giving us any personal information.
          However, we will need additional information about you in order to
          provide any information or services you are requesting.
        </p>
        <h4>The information we collect on this site</h4>
        <p>
          On some pages you may opt to provide us information about yourself if
          you are interested in (a) an employment opportunity at Healthcare
          interaction; or (b) in receiving further information on our bespoke
          Advance® systems or our other products and services.
        </p>
        <h4>The way we use information</h4>
        <p>
          We store the information you provide about yourself in a secure
          environment in order to provide you with the information, products,
          and/or services you request. The information is stored for the
          lifetime of the system unless you request that it be removed. The
          information you provide us about yourself will be shared only with
          Healthcare interaction employees to the extent necessary to
          accommodate your request.
        </p>
        <p>
          For example, if you provide your name, address, telephone and email
          address and request more information about our products and services,
          this information will be shared with appropriate personnel to fulfill
          your request. This information will not be shared with any outside
          third parties.
        </p>
        <p>
          Finally, we would not use your personal information provided to us
          online for purposes other than those you requested without also
          providing you an opportunity to agree or otherwise limit such
          unrelated purposes.
        </p>
        <h4>Exceptions</h4>
        <p>
          We will not otherwise use or disclose any of your personally
          identifiable information, except to the extent reasonably necessary:
          (i) to correct technical problems and malfunctions and when we process
          your information; (ii) to protect the security and integrity of our
          Web site; (iii) to protect our rights and property and the rights and
          property of others; (iv) to take precautions against liability; (v) to
          comply with laws or to respond to judicial process; or (vii) to
          provide information to law enforcement agencies or for an
          investigation on a matter as applicable or otherwise required or
          permitted by law.
        </p>
        <h4>Our commitment to data security</h4>
        <p>
          To prevent unauthorized access, maintain data accuracy, and ensure the
          correct use of information, we have put in place appropriate physical,
          electronic, and managerial procedures to safeguard and secure the
          information we collect online.
        </p>
        <h4>Cookies and other anonymous web tracking techniques</h4>
        <p>
          We do not use 'Cookies' or any other anonymous web tracking techniques
          on our site.
        </p>
        <h4>Links to other web sites</h4>
        <p>
          Our Web site may contain links to other Web sites. You should
          carefully review the privacy policies and practices of other Web
          sites, as we cannot control or be responsible for privacy policies or
          practices of third-party Web sites.
        </p>
        <h4>Further Questions</h4>
        <p>
          Should you have other questions or concerns about this privacy policy,
          please contact us via email in the first instance at:
          info@healthcareinteraction.com
        </p>
      </section>
    </>
  );
};

export default privacyPolicy;
